import { CoinsProvider } from './../../providers/coins/coins';
import { Portfolio } from './../../models/Portfolio';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the PortfolioSummaryHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'portfolio-summary-header',
  templateUrl: 'portfolio-summary-header.html'
})
export class PortfolioSummaryHeaderComponent {
  @Input('portfolio') portfolio: Portfolio;
  constructor(public CP: CoinsProvider) {

  }

}



// WEBPACK FOOTER //
// ./src/components/portfolio-summary-header/portfolio-summary-header.ts